import { getIsCountriesApiPending, getQuoteForm } from '../../../selectors/travelSs/quote';
import { apiTransitionCountries, setCountriesList } from '../../../actions/travelSs/quote';
import { getAccessToken } from '../../../selectors/travelSs/payments';
import axios from 'axios';

export const getCountriesService = (store, next, action) => {
    const quotation = getQuoteForm(store.getState());
    
    let countriesType = 'Holiday';

    if (quotation.selectedCover.value === 'Schengen') {
        countriesType = 'Schengen';
    }

    if (quotation.selectedCover.value === 'East Africa') {
        countriesType = 'East Africa';
    }

    if (quotation.selectedCover.value === 'Senior') {
        countriesType = 'Senior';
    }

    if (quotation.selectedCover.value === 'Holiday') {
        countriesType = 'Holiday';
    }


    function convertToObjects(array) {
        return array
            .map(item => ({ name: item }));     // Map each item to an object with a 'name' property
    }
    
    (async () => {
        if (!getIsCountriesApiPending(store.getState())) {
            store.dispatch(apiTransitionCountries.pending());
            try {
                
                const resp = await getCountries(store.getState());

                // Ensure `resp.data` is an array
                let countriesArr = []
                if(quotation.selectedCover.value === 'Schengen' || quotation.selectedCover.value === 'East Africa'){
                    countriesArr = convertToObjects(Array.isArray(resp.data.data) ? [...resp.data.data] : []);
                }else{
                    countriesArr = Array.isArray(resp.data) ? [...resp.data] : [];
                }
                // Find and remove Uganda if it exists
                const index = countriesArr.findIndex((country) => country.name === 'South Sudan');
                if (index !== -1) {
                    countriesArr.splice(index, 1);
                }

                // Sort the array alphabetically by country name
                countriesArr.sort((a, b) => a.name.localeCompare(b.name));
                store.dispatch(setCountriesList(countriesArr));
                store.dispatch(apiTransitionCountries.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionCountries.failure());
            }
        }
    })();
    return next(action);
};

const getCountries = async (state) => {
    const loginData = getAccessToken(state);

    const quotation = getQuoteForm(state);

    let countriesType = 'Worldwide';

    if (quotation.selectedCover.value === 'Schengen') {
        countriesType = 'Schengen';
    }

    if (quotation.selectedCover.value === 'East Africa') {
        countriesType = 'East Africa';
    }

    try {
        const url = '/om-api/travel-ss/countries';
        return await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                countriesType: countriesType,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
